const SET_ORDER_APPROVAL_REQUEST = 'SET_ORDER_APPROVAL_REQUEST';
const SET_APPROVAL_REQUEST_OPTION_ = 'SET_APPROVAL_REQUEST_OPTION_';

const SET_QUANTITY_APPROVAL_OPTION = 'SET_QUANTITY_APPROVAL_OPTION';
const SET_SELECTED_OPTIONS_SUBMIT = 'SET_SELECTED_OPTIONS_SUBMIT'

const SET_FINAL_SAVE_APPROVAL_MANAGEMENT = "SET_FINAL_SAVE_APPROVAL_MANAGEMENT"

const SET_IS_SUPER_ADMIN_APPROVAL_PAGE = "SET_IS_SUPER_ADMIN_APPROVAL_PAGE"
const SET_IS_OVERRIDE_ACTION_APPLICABLE = 'SET_IS_OVERRIDE_ACTION_APPLICABLE'
export
{
    SET_ORDER_APPROVAL_REQUEST,
    SET_APPROVAL_REQUEST_OPTION_,
    SET_QUANTITY_APPROVAL_OPTION,
    SET_SELECTED_OPTIONS_SUBMIT,
    SET_FINAL_SAVE_APPROVAL_MANAGEMENT,
    SET_IS_SUPER_ADMIN_APPROVAL_PAGE,
    SET_IS_OVERRIDE_ACTION_APPLICABLE
};
